import React from "react";
import "./BracksetFooter.css";
import { navigateToContactUsPage } from "utilities/js/NavigationHelper";
import Constants from "utilities/js/Constants";


const LogoIcon = Constants.ICON_LOGO;
const InstagramLogo = Constants.ICON_INSTAGRAM;
const TwitterLogo = Constants.ICON_TWITTER;
const InstagramLogoBlue = Constants.ICON_INSTAGRAM_BLUE;
const TwitterLogoBlue = Constants.ICON_TWITTER_BLUE;


class BracksetFooter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };

    }



    componentDidMount() {
    }


    get fullFooter(){
        return (
        <div className="brackset-footer">
            <div className="brackset-footer-logo">
                <div className="brackset-footer-logo-container">
                    <img className="brackset-footer-logo-icon" src={LogoIcon} alt="logo-icon"></img>
                    <div className="brackset-footer-logo-name">Brackset</div>
                </div>
                <div className="brackset-footer-logo-tagline">The worldwide leader in bracket generation</div>

            </div>
            <div className="brackset-footer-links">
                <div className="brackset-footer-socials">
                    <img className="brackset-footer-social-icon" src={TwitterLogo} alt="logo-icon"></img>
                    <img className="brackset-footer-social-icon" src={InstagramLogo} alt="logo-icon"></img>

                </div>
                <div className="brackset-footer-contact-us">
                    <div className="contact-us-prompt">Questions? Feedback? Please reach out and let us know</div> 
                    <button className="contact-us-button" onClick={navigateToContactUsPage}>Contact Us</button>
                </div>
            </div>
        </div>
        );
    }

    get variantFooter(){
        return (
        <div className="brackset-footer-alt">
            
            <div className="brackset-footer-links">
                <div className="brackset-footer-socials">
                    <img className="brackset-footer-social-icon" src={TwitterLogoBlue} alt="logo-icon"></img>
                    <img className="brackset-footer-social-icon" src={InstagramLogoBlue} alt="logo-icon"></img>

                </div>
                <div className="brackset-footer-contact-us">
                    <div className="contact-us-prompt">Questions? Feedback? Please reach out and let us know</div> 
                    <button className="contact-us-button" onClick={navigateToContactUsPage}>Contact Us</button>
                </div>
            </div>
        </div>
        );
    }

    render() {
        
        if(this.props.variant){
            return this.variantFooter;
        }else{
            return this.fullFooter;
        }
        // return (<>
        //     <div className="brackset-footer">
        //         <div className="brackset-footer-logo">
        //             <div className="brackset-footer-logo-container">
        //                 <img className="brackset-footer-logo-icon" src={LogoIcon} alt="logo-icon"></img>
        //                 <div className="brackset-footer-logo-name">Brackset</div>
        //             </div>
        //             <div className="brackset-footer-logo-tagline">The worldwide leader in bracket generation</div>

        //         </div>
        //         <div className="brackset-footer-links">
        //             <div className="brackset-footer-socials">
        //                 <img className="brackset-footer-social-icon" src={TwitterLogo} alt="logo-icon"></img>
        //                 <img className="brackset-footer-social-icon" src={InstagramLogo} alt="logo-icon"></img>

        //             </div>
        //             <div className="brackset-footer-contact-us">
        //                 <div className="contact-us-prompt">Questions? Feedback? Please reach out and let us know</div> 
        //                 <button className="contact-us-button" onClick={navigateToContactUsPage}>Contact Us</button>
        //             </div>
        //         </div>
        //     </div>
        // </>)
    }
}

export default BracksetFooter;
